import type { FC } from 'react';
import React from 'react';

import type { IStickyContainerProps } from './models';

export const StickyContainer: FC<IStickyContainerProps> = ({ ReactStickyContainer, children }) => (
    <ReactStickyContainer>{children}</ReactStickyContainer>
);
